<template>
  <WidgetPanel>
    <template #header>
      <div class="flex justify-between items-center">
        <h3 class="widget-headline">
          Umsetzung
        </h3>
        <SubmitButton @click="onSubmit" :load="creating" v-if="!empty">
          Alles erledigt
        </SubmitButton>
      </div>
    </template>
    <template #default>
      <section v-if="empty">
        <div class="px-4 py-5 sm:px-6">
          <p class="mt-1 max-w-2xl text-sm text-gray-500">
            Ich arbeite noch an detaillierten Anleitungsschritten für diese Methode. Halte dich solange bitte an die Beschreibung oder entdecke weitere Tipps auf der Detailseite zur Methode!
          </p>
        </div>
      </section>
      <section v-else="empty">
        <ul role="list" class="divide-y divide-gray-200">
          <ActionWidgetItem v-for="a in records" :key="a.id" :action="a" ref="items" as="li" @updated="onUpdated" />
        </ul>
      </section>
    </template>
  </WidgetPanel>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useCreateResource } from '@/client/actions';

const props = defineProps({experiment: Object});
const emits = defineEmits(['updated']);

const items = ref();
const loading = ref(false);

const records = computed(() => props.experiment.actions);
const empty = computed(() => props.experiment.actions.length == 0);
const parent = computed(() => props.experiment.id);
const target = computed(() => '/api/experiments/' + parent.value + '/actions');

const { creating, create } = useCreateResource(target);

const onSuccess = () => emits('updated');
const onSubmit = () => create(onSuccess);
const onUpdated = () => onSuccess();
</script>
